import { render, staticRenderFns } from "./BackOff.vue?vue&type=template&id=797a05e1&"
import script from "./BackOff.vue?vue&type=script&lang=js&"
export * from "./BackOff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports